import React from "react";
import InputDropDown from "./InputDropDown";

const InputRadio = (props) => (
	<InputDropDown
		{...props}
		required={true}
		defaultName={props.defaultName || "Select An Option"}
	/>
);

export default InputRadio;
